export default __webpack_public_path__ + "3ae923099762fd3bf2e9b101b986c995.png";